// src/reducers/userReducer.js
import {
    GET_ABOUT_SUCCESS,
    GET_ABOUT_FAILURE,
  } from "../../actions/types";
  
  const initialState = {
    isLoading: false,
    response: null,
    error: null,
  };
  
  export const aboutReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_ABOUT_SUCCESS:
        return {
          ...state,
          isLoading: false,
          response: action.payload,
          error: null,
        };
      case GET_ABOUT_FAILURE:
        return {
          ...state,
          isLoading: false,
          response: null,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  